import React, {Component} from 'react'
import {RouteContext} from './context'

export default (permission) => {
    return (CC) => {
        return class extends Component {
            render() {
                return (
                    <RouteContext.Consumer>
                        {({permissions}) => {
                            if (permissions.indexOf(permission) !== -1) {
                                return <CC {...this.props}/>
                            } else {
                                return null
                            }
                        }}
                    </RouteContext.Consumer>
                )
            }
        }
    }
}